import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'loading-configuration',
  templateUrl: './loading-configuration.component.html',
  styleUrls: ['./loading-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingConfigurationComponent {}
